import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { PlacementReportsGridPostParams } from 'common/models/page-models/reports/placement-reports/placement-grid-params';
import { PlacementReportsModel } from 'common/models/page-models/reports/placement-reports/placement-report-data.model';
import { PlacementChartsModel } from 'common/models/page-models/reports/placement-reports/placement-reports-charts.model';
import { PlacementReportsListingModel } from 'common/models/page-models/reports/placement-reports/placement-reports-grid-model';


@Injectable({
  providedIn: 'root'
})
export class PlacementReportsDataService extends GridDataService<PlacementReportsListingModel, PlacementReportsModel> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.fetchReportData, http, ss);
  }

  createInstance(): PlacementReportsListingModel {
    return new PlacementReportsListingModel();
  }

  getDeleteUrl() {
    return '';
  }

  override getGridParams(param): GridPostParams {
    return new PlacementReportsGridPostParams();
  }

  override transformDataModel(data: any[], param: any) {
    super.transformDataModel(data, param);
    if (data.hasOwnProperty(param)) {
      data[param].forEach(element => {
        element.isKT = element.overallKtStatus === 0 ? 'No' : 'Yes';
      });
    }else{
      // console.log('No records found for given combination');
      this.ss.showError('No records found for given combination')
    }
    return data;
  }

  override modifyGridPostParams(queryParams) {
    let payload = this.getGridParams(queryParams);
    if (queryParams.transferData !== null) {
      payload['batch_search'] = queryParams.transferData.selectedBatch === null ? '' : queryParams.transferData.selectedBatch;
      payload['region_search'] = queryParams.transferData.selectedRegion === null ? '' : queryParams.transferData.selectedRegion;
      payload['branch_search'] = queryParams.transferData.selectedBranch === null ? '' : queryParams.transferData.selectedBranch;
      payload['state_search'] = queryParams.transferData.selectedState === null ? '' : queryParams.transferData.selectedState;
      payload['gender_search'] = queryParams.transferData.selectedGender === null ? '' : queryParams.transferData.selectedGender;
      payload['status_search'] = queryParams.transferData.selectedStatus === null ? '' : queryParams.transferData.selectedStatus;
      payload['internship_company_search'] = queryParams.transferData.selectedCompany === null ? '' : queryParams.transferData.selectedCompany;
      payload['considerYear_search'] = queryParams.transferData.selectedYear === null ? '' : queryParams.transferData.selectedYear;

    }
    return payload;
  }

  override prepareChartsData(apiData) {
    const chartsModel = new PlacementChartsModel();
    let lessThan5 = 0;
    let lessThan3 = 0;
    let lessThan10 = 0;
    let greaterThan10 = 0;

    apiData.forEach((key) => {
      if (key.placement_company_package === "3 To 5 LPA") {
        lessThan5 = lessThan5 + 1;
      } else if (key.placement_company_package === "< 3 LPA") {
        lessThan3 = lessThan3 + 1;
      } else if (key.placement_company_package === "5 To 10 LPA") {
        lessThan10 = lessThan10 + 1;
      } else if (key.placement_company_package === "> 10 LPA") {
        greaterThan10 = greaterThan10 + 1;
      }
    })


    chartsModel.placementChart.options = {
      chart: {
        type: "column",
      },
      title: {
        align: "left",
        text: "Student Placement Analysis",
      },
      accessibility: {
        announceNewData: {
          enabled: true,
        },
      },
      xAxis: {
        type: "category",
        title: {
          text: "CTC Offered",
        },
      },
      yAxis: {
        title: {
          text: "Count",
        },
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            format: "{y}",
          },
        },
      },

      tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:
          '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}</b><br/>',
      },

      series: [
        {
          name: "Count",
          colorByPoint: true,
          data: [
            {
              name: "< 3 LPA",
              y: lessThan3,
              drilldown: "< 3 LPA",
              color: "#86C8BC",
            },
            {
              name: "3 To 5 LPA",
              y: lessThan5,
              drilldown: "3 To 5 LPA",
              color: "#CEEDC7",
            },
            {
              name: "5 To 10 LPA",
              y: lessThan10,
              drilldown: "5 To 10 LPA",
              color: "#FFF6BD",
            },
            {
              name: "> 10 LPA",
              y: greaterThan10,
              drilldown: "> 10 LPA",
              color: "#FFD4B2",
            },
          ],
        },
      ],
    };

    // chartsModel.studentScoreChart.data = {
    //     continue: continued,
    //     continueColor: '#0e6052',
    //     disContinue: discontinued,
    //     disContinueColor: '#01a185',
    //     complete: completed,
    //     completeColor: '#17d5b3',
    //     incomplete: incompleted,
    //     incompletedColor: '#61e1ca',
    //     notJoined: notJoined,
    //     notJoinedColor: '#9cffed'
    // }
    return chartsModel;
  }
}
